import React from 'react';

const CarIcon = () => {
    return (
        <svg
            fill="none"
            height="28"
            viewBox="0 0 43 28"
            width="43"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M31.9941 10.491L39.4365 10.491V10.2527C39.4365 9.54234 39.1519 8.86111 38.6454 8.35883C38.1389 7.85656 37.4519 7.57438 36.7356 7.57438H31.9941V10.491Z"
                fill="#81D248"
            />
            <path
                clipRule="evenodd"
                d="M42.5572 24.1157H31.9887V9.26801H39.2726C39.8141 9.26801 40.294 9.58994 40.4634 10.0662L42.6444 16.2082C42.6882 16.3316 42.7094 16.4618 42.7068 16.5927L42.5572 24.1157ZM34.8634 16.2296H40.3677C40.4642 16.2294 40.5592 16.2069 40.6453 16.1639C40.7315 16.1209 40.8062 16.0584 40.8636 15.9817C40.9211 15.9049 40.9596 15.8158 40.9761 15.7216C40.9927 15.6274 40.9868 15.5307 40.9589 15.4391L39.5707 10.9495C39.532 10.824 39.4537 10.7141 39.3474 10.636C39.241 10.558 39.1122 10.5158 38.9798 10.5157H34.8634C34.6995 10.5158 34.5424 10.5804 34.4265 10.6953C34.3106 10.8103 34.2455 10.9661 34.2454 11.1286V15.6167C34.2455 15.7792 34.3106 15.935 34.4265 16.05C34.5424 16.1649 34.6995 16.2295 34.8634 16.2296Z"
                fill="#64B82A"
                fillRule="evenodd"
            />
            <path
                d="M42.0475 24.1157H42.7068V21.5653H42.0475C41.9357 21.5653 41.8285 21.6094 41.7494 21.6878C41.6704 21.7662 41.626 21.8725 41.626 21.9833V23.698C41.626 23.7529 41.6369 23.8072 41.6581 23.8579C41.6793 23.9086 41.7103 23.9546 41.7495 23.9934C41.7886 24.0322 41.8351 24.063 41.8862 24.084C41.9373 24.1049 41.9921 24.1157 42.0475 24.1157Z"
                fill="#E6BA4D"
            />
            <path
                d="M11.2085 27.0266C9.58719 27.0266 8.27288 25.7226 8.27288 24.1139C8.27288 22.5053 9.58719 21.2012 11.2085 21.2012C12.8297 21.2012 14.144 22.5053 14.144 24.1139C14.144 25.7226 12.8297 27.0266 11.2085 27.0266Z"
                fill="#39444F"
            />
            <path
                d="M29.0654 19.9486L1.80909 19.9486C1.33177 19.9486 0.944824 19.5649 0.944824 19.0916L0.944824 1.43767C0.944824 0.964346 1.33177 0.580643 1.80909 0.580643L29.0654 0.580643C29.5427 0.580643 29.9297 0.964346 29.9297 1.43767L29.9297 19.0916C29.9297 19.5649 29.5427 19.9486 29.0654 19.9486Z"
                fill="#DEA00A"
            />
            <path
                d="M1.80934 19.1579C1.79163 19.1578 1.77467 19.1508 1.76215 19.1384C1.74963 19.1259 1.74256 19.1091 1.74247 19.0916V1.43764C1.74256 1.42003 1.74967 1.40317 1.76226 1.39074C1.77485 1.37831 1.79189 1.37134 1.80965 1.37134H16.9688V19.1579H1.80934Z"
                fill="#596E81"
            />
            <path
                d="M28.3193 27.0266C26.698 27.0266 25.3837 25.7226 25.3837 24.1139C25.3837 22.5053 26.698 21.2012 28.3193 21.2012C29.9406 21.2012 31.2549 22.5053 31.2549 24.1139C31.2549 25.7226 29.9406 27.0266 28.3193 27.0266Z"
                fill="#39444F"
            />
            <path
                d="M1.80934 6.08748C1.77247 6.08748 1.74216 6.07943 1.74216 6.06982V1.38283C1.74216 1.37322 1.77341 1.36548 1.80934 1.36548H16.9688V6.08748H1.80934Z"
                fill="#DEA00A"
            />
            <path
                d="M1.80934 2.06088C1.77247 2.06088 1.74216 2.05969 1.74216 2.05828V1.36803C1.74216 1.36662 1.77341 1.36548 1.80934 1.36548H16.9688V2.06088H1.80934Z"
                fill="#E6BA4D"
            />
            <path
                d="M1.80934 2.93503C1.77247 2.93503 1.74216 2.93384 1.74216 2.93243V2.24218C1.74216 2.24076 1.77341 2.23962 1.80934 2.23962H16.9688V2.93503H1.80934Z"
                fill="#E6BA4D"
            />
            <path
                d="M1.80934 3.80917C1.77247 3.80917 1.74216 3.80799 1.74216 3.80657V3.11632C1.74216 3.11491 1.77341 3.11377 1.80934 3.11377H16.9688V3.80917H1.80934Z"
                fill="#E6BA4D"
            />
            <path
                d="M1.80934 4.68332C1.77247 4.68332 1.74216 4.68213 1.74216 4.68072V3.99047C1.74216 3.98906 1.77341 3.98792 1.80934 3.98792H16.9688V4.68332H1.80934Z"
                fill="#E6BA4D"
            />
            <path
                d="M1.80934 5.55797C1.77247 5.55797 1.74216 5.55678 1.74216 5.55537V4.86462C1.74216 4.8632 1.77341 4.86206 1.80934 4.86206H16.9688V5.55797H1.80934Z"
                fill="#E6BA4D"
            />
            <path
                d="M17.7662 0.580627H31.8286C32.0578 0.580627 32.2776 0.670921 32.4397 0.831645C32.6018 0.992368 32.6929 1.21035 32.6929 1.43765L32.6929 19.9486H17.7662V0.580627Z"
                fill="#E6BA4D"
            />
            <path
                d="M22.2786 3.98792L28.5277 3.98792L24.5627 8.67077H28.9873L22.047 17.7438L23.0879 11.0122H20.4331L22.2786 3.98792Z"
                fill="#DEA00A"
            />
            <path
                d="M23.0071 3.98792L29.2562 3.98792L25.2913 8.67077H29.7159L22.0465 17.7438L23.8164 11.0122H21.1616L23.0071 3.98792Z"
                fill="#FFECC0"
            />
            <path
                d="M9.77713 19.1579H3.31885L3.31885 13.8218H9.77713V19.1579Z"
                fill="#478CC8"
            />
            <path
                d="M6.6411 19.1579H3.31885L3.31885 13.8218H6.6411V19.1579Z"
                fill="#7BBAF0"
            />
            <path
                d="M16.9687 19.1579H8.82031V12.7782H16.9687V19.1579Z"
                fill="#478CC8"
            />
            <path
                d="M13.1897 19.1579H8.82031V12.7782H13.1897V19.1579Z"
                fill="#7BBAF0"
            />
            <path
                d="M16.9687 12.7782H10.0161V8.07537H16.9687V12.7782Z"
                fill="#478CC8"
            />
            <path
                d="M14.43 12.7782H10.0161V8.07537H14.43V12.7782Z"
                fill="#6AACE7"
            />
            <path
                d="M12.6358 8.89471H11.8101V8.07539H12.6358V8.89471Z"
                fill="#478CC8"
            />
            <path
                d="M11.418 13.5975H10.5923V12.7782H11.418V13.5975Z"
                fill="#478CC8"
            />
            <path
                d="M5.39265 14.6411H4.56689V13.8218H5.39265V14.6411Z"
                fill="#478CC8"
            />
            <path
                d="M31.8873 24.1157L3.03174 24.1157L3.03174 19.9483L32.6903 19.9483V23.3194C32.6903 23.5306 32.6057 23.7331 32.4551 23.8824C32.3045 24.0318 32.1003 24.1157 31.8873 24.1157Z"
                fill="#DEA00A"
            />
            <path
                d="M16.9687 23.6171H3.31885L3.31885 20.5106H16.9687V23.6171Z"
                fill="#E6BA4D"
            />
            <path
                d="M16.0108 22.6805H11.9609V21.4473H16.0108V22.6805Z"
                fill="#B5000F"
            />
            <path
                d="M16.0107 22.6805H13.5669V21.4473H16.0107V22.6805Z"
                fill="#D0021B"
            />
            <path
                d="M8.27297 22.6805H4.22314V21.4473H8.27297V22.6805Z"
                fill="#B5000F"
            />
            <path
                d="M6.05699 22.6805H4.22314V21.4473H6.05699V22.6805Z"
                fill="#D0021B"
            />
            <path
                d="M19.7908 27.0265C18.0267 27.0265 16.5966 25.6076 16.5966 23.8572C16.5966 22.1069 18.0267 20.688 19.7908 20.688C21.5548 20.688 22.9849 22.1069 22.9849 23.8572C22.9849 25.6076 21.5548 27.0265 19.7908 27.0265Z"
                fill="#39444F"
            />
            <rect
                fill="#39444F"
                height="6.3385"
                transform="matrix(-1 0 0 1 20.6968 20.688)"
                width="1.02285"
            />
            <path
                d="M20.697 27.0266C18.9329 27.0266 17.5029 25.6076 17.5029 23.8572C17.5029 22.1068 18.9329 20.6879 20.697 20.6879C22.4611 20.6879 23.8911 22.1068 23.8911 23.8572C23.8911 25.6076 22.4611 27.0266 20.697 27.0266Z"
                fill="#596E81"
            />
            <path
                d="M22.2676 23.8572C22.2676 24.718 21.5646 25.4157 20.6971 25.4157C19.8296 25.4157 19.1266 24.718 19.1266 23.8572C19.1266 22.9965 19.8299 22.2987 20.6971 22.2987C21.5643 22.2987 22.2676 22.9955 22.2676 23.8572Z"
                fill="#E8F4FF"
            />
            <path
                d="M36.8948 27.0265C35.1307 27.0265 33.7006 25.6076 33.7006 23.8572C33.7006 22.1069 35.1307 20.688 36.8948 20.688C38.6588 20.688 40.0889 22.1069 40.0889 23.8572C40.0889 25.6076 38.6588 27.0265 36.8948 27.0265Z"
                fill="#39444F"
            />
            <rect
                fill="#39444F"
                height="6.33851"
                transform="matrix(-1 0 0 1 37.8008 20.688)"
                width="1.02285"
            />
            <path
                d="M37.801 27.0266C36.0369 27.0266 34.6069 25.6077 34.6069 23.8572C34.6069 22.1068 36.0369 20.6879 37.801 20.6879C39.5651 20.6879 40.9951 22.1068 40.9951 23.8572C40.9951 25.6077 39.5651 27.0266 37.801 27.0266Z"
                fill="#596E81"
            />
            <path
                d="M39.3716 23.8572C39.3716 24.718 38.6686 25.4157 37.8011 25.4157C36.9336 25.4157 36.2306 24.718 36.2306 23.8572C36.2306 22.9965 36.9339 22.2987 37.8011 22.2987C38.6683 22.2987 39.3716 22.9955 39.3716 23.8572Z"
                fill="#E8F4FF"
            />
            <path
                d="M8.1706 4.86206H10.8975C10.8975 4.95343 10.8794 5.04392 10.8442 5.12835C10.8089 5.21278 10.7573 5.2895 10.6921 5.35412C10.627 5.41875 10.5496 5.47001 10.4645 5.50499C10.3794 5.53996 10.2881 5.55797 10.196 5.55797H8.87208C8.77993 5.55797 8.68869 5.53996 8.60356 5.50499C8.51843 5.47001 8.44109 5.41875 8.37595 5.35412C8.31081 5.2895 8.25914 5.21278 8.22391 5.12835C8.18867 5.04392 8.17056 4.95343 8.1706 4.86206Z"
                fill="#596E81"
            />
            <path
                d="M39.8703 18.3501H41.3076V17.719H39.2326C39.2326 17.802 39.2491 17.8842 39.2811 17.9608C39.3132 18.0375 39.3602 18.1071 39.4194 18.1657C39.4787 18.2243 39.549 18.2708 39.6263 18.3025C39.7037 18.3341 39.7866 18.3503 39.8703 18.3501Z"
                fill="#80D248"
            />
        </svg>

    );
};

export default CarIcon;